import React, { useState } from "react";
import { FaPencil } from "react-icons/fa6";
import VistaDetalleExpo from "./vistaDetalleExpo";

function ExpoTariff() {
  const [vistaActiva, setVistaActiva] = useState(null);

  // 🔹 Simulación de datos que vendrían del back
  const [tarifas, setTarifas] = useState({
    management: [{ v1: 100, v2: 200, v3: 300, activo: true }],
    value_management: [{ v1: 200, v2: 400, v3: 600, activo: true }],
    inspection: 150,
    refrigeration: {
      tabla: [
        { v1: 0, v2: 10, v3: 1, v4: 3 },
        { v1: 11, v2: 20, v3: 4, v4: 6 },
      ],
      cargoMinimo: 750,
    },
    congelation: {
      tabla: [
        { v1: 0, v2: 10, v3: 1, v4: 3 },
        { v1: 11, v2: 20, v3: 4, v4: 6 },
      ],
      cargoMinimo: 920,
    },
    dangerous_goods: {
      tres: 120,
      uno: 150,
      notoc: 45,
    },
    dry_ice: 200,
    live_animals: 500,
    cancelation_factura: 300,
    strapping_packaging: {
      skid: 120,
      pieza: 150,
      medio: 45,
      std: 50
    },

    previos_maniobras: [{ v1: 500, v2: 400, v3: 600, activo: true }],
    custodia: {
      tabla: [{ v1: 0, v2: 100, v3: 250, activo: false }],
      formula: {
        divisor: 1000,
        porcentaje: 5,
      },
    },
    almacenaje: {
      tabla: [
        { v1: 0, v2: 10, v3: 1, v4: 3, v5: 150 },
        { v1: 11, v2: 20, v3: 4, v4: 6, v5: 200 },
      ],
      cargoMinimo: 500,
    },
    servicio_extraordinario: 150,
    restos_humanos: 2000,
  });

  const actualizarTarifa = (concepto, nuevoValor) => {
    setTarifas((prev) => ({
      ...prev,
      [concepto]: nuevoValor,
    }));
  };

  const conceptos = [
    { id: "management", nombre: "Manejo" },
    { id: "value_management", nombre: "Manejo por valor" },
    { id: "inspection", nombre: "Inspección" },
    { id: "refrigeration", nombre: "Refrigeración" },
    { id: "congelation", nombre: "Congelación" },
    { id: "dangerous_goods", nombre: "Mercancias Peligrosas" },
    { id: "dry_ice", nombre: "Hielo Seco" },
    { id: "live_animals", nombre: "Animales Vivos" },
    { id: "cancelation_factura", nombre: "Cancelación de Factura" },
    { id: "strapping_packaging", nombre: "Fleje y Empaque" },
    { id: "contenedores_activos", nombre: "Contenedores Activos" },
    { id: "restos_humanos", nombre: "Restos Humanos" },
  ];

  return (
    <>
      <div className="container-fluid">
        {vistaActiva ? (
          <VistaDetalleExpo
            concepto={vistaActiva}
            onClose={() => setVistaActiva(null)}
            tarifas={tarifas}
            actualizarTarifa={actualizarTarifa}
          />
        ) : (
          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row" className="text-center">
                    <th>Concepto</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {conceptos.map((concepto, index) => (
                    <tr key={index}>
                      <td>{concepto.nombre}</td>
                      <td>
                        <FaPencil
                          style={{ cursor: "pointer" }}
                          onClick={() => setVistaActiva(concepto.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ExpoTariff;
